import { useCallback, useEffect, useState } from "react";
import { Multitool, RunStrategy, Task, TaskDefinition, } from "multitool-sdk-core";
import { APITaskDefinition } from "./APITaskDefinition";
import { BrowserInlineTaskDefinition } from "./BrowserInlineTaskDefinition";
import { BrowserWorkerTaskDefinition } from "./BrowserWorkerTaskDefinition";
export function useCreateTask({ pkg, name, args, workerURL, inlineHandler, strategies, runOnChange = false, }) {
    const [task, setTask] = useState();
    const [def, setDef] = useState();
    const [sharedWorker, setSharedWorker] = useState();
    const [strategy, setStrategy] = useState(strategies[0]);
    const onMessage = useCallback(async (e) => {
        console.log("ui received message from worker", e.data);
        const t = new Task({ ...JSON.parse(e.data), def });
        setTask(t);
    }, [def]);
    useEffect(() => {
        // TODO - do something smart to choose one of the supported strategies.
        setStrategy(strategies[0]);
    }, [strategies]);
    useEffect(() => {
        if (sharedWorker) {
            sharedWorker.port.addEventListener("message", onMessage);
            return () => {
                sharedWorker.port.removeEventListener("message", onMessage);
            };
        }
    }, [sharedWorker, onMessage]);
    useEffect(() => {
        if (strategy === RunStrategy.SHARED_WORKER) {
            if (typeof SharedWorker === "undefined") {
                return;
            }
            const w = new SharedWorker(new URL(workerURL, import.meta.url), {
                type: "module",
            });
            w.port.start();
            setDef(new BrowserWorkerTaskDefinition({
                pkg,
                name,
                worker: w,
            }));
            setSharedWorker(w);
            w.port.postMessage(JSON.stringify({
                type: "init",
                user: Multitool.INSTANCE.user,
                env: Multitool.INSTANCE.env,
            }));
            return () => {
                w.port.close();
                setSharedWorker(undefined);
            };
        }
        else if (strategy === RunStrategy.INLINE) {
            setDef(new BrowserInlineTaskDefinition({
                pkg,
                name,
                handler: inlineHandler,
            }));
        }
        else if (strategy === RunStrategy.API) {
            setDef(new APITaskDefinition({
                pkg,
                name,
                handler: inlineHandler,
            }));
        }
        else {
            throw new Error(`Unsupported strategy : ${strategy}`);
        }
    }, [pkg, name, workerURL, inlineHandler, strategy]);
    useEffect(() => {
        if (def) {
            const t = new Task({ def, args });
            t.onChange = async (t) => {
                console.log("change", new Task(t));
                setTask(new Task(t));
            };
            if (runOnChange && args !== undefined) {
                void t.run();
            }
            setTask(t);
        }
    }, [args, def, runOnChange]);
    return {
        task,
    };
}
//# sourceMappingURL=useCreateTask.js.map